import {
  Component,
  Inject,
  Input,
  LOCALE_ID
} from '@angular/core';

import { TreeCategory } from '@p1/libs/catalog-service';

import { CatalogConfigLinkTile } from '../../catalog-config/model/catalog-config';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'p1-category-tree-list',
  templateUrl: './category-tree-list.component.html',
  styleUrls: ['./category-tree-list.component.scss']
})
export class CategoryTreeListComponent {
  @Input()
  categoryTree: TreeCategory[];

  @Input()
  subPageLinkPrefix: string;

  @Input()
  rootCategory: boolean = false;

  @Input()
  background: boolean = true;

  @Input()
  linkTiles: CatalogConfigLinkTile[];

  featureFlags = environment.featureFlags;
  iphasCatalog = environment.catalogIdentifier === 'HamburgerArchitekturSommer';
  constructor(@Inject(LOCALE_ID) public locale: string) {}

  identifyCategory(_, category: TreeCategory) {
    return category.uuid;
  }

  identifyLinkTile(_, linkTile: CatalogConfigLinkTile) {
    return linkTile.name;
  }

  isProduction() {
    if (environment.environmentName === 'prod'){
      return true;
    }
  }
}
